<template>
	<div class="kt-aside  kt-aside--fixed  kt-grid__item kt-grid kt-grid--desktop kt-grid--hor-desktop" id="kt_aside">
		<div class="kt-aside__brand kt-grid__item " id="kt_aside_brand">
			<div class="kt-aside__brand-logo">
				<router-link to="/dashboard"><img alt="Logo" src="@/assets/media/logo-2.21.png" width="200" /></router-link>
			</div>
			<div class="kt-aside__brand-tools">
				<button class="kt-aside__brand-aside-toggler" id="kt_aside_toggler">
					<span>
						<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
							<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
								<polygon id="Shape" points="0 0 24 0 24 24 0 24" />
								<path d="M5.29288961,6.70710318 C4.90236532,6.31657888 4.90236532,5.68341391 5.29288961,5.29288961 C5.68341391,4.90236532 6.31657888,4.90236532 6.70710318,5.29288961 L12.7071032,11.2928896 C13.0856821,11.6714686 13.0989277,12.281055 12.7371505,12.675721 L7.23715054,18.675721 C6.86395813,19.08284 6.23139076,19.1103429 5.82427177,18.7371505 C5.41715278,18.3639581 5.38964985,17.7313908 5.76284226,17.3242718 L10.6158586,12.0300721 L5.29288961,6.70710318 Z" id="Path-94" fill="#000000" fill-rule="nonzero" transform="translate(8.999997, 11.999999) scale(-1, 1) translate(-8.999997, -11.999999) " />
								<path d="M10.7071009,15.7071068 C10.3165766,16.0976311 9.68341162,16.0976311 9.29288733,15.7071068 C8.90236304,15.3165825 8.90236304,14.6834175 9.29288733,14.2928932 L15.2928873,8.29289322 C15.6714663,7.91431428 16.2810527,7.90106866 16.6757187,8.26284586 L22.6757187,13.7628459 C23.0828377,14.1360383 23.1103407,14.7686056 22.7371482,15.1757246 C22.3639558,15.5828436 21.7313885,15.6103465 21.3242695,15.2371541 L16.0300699,10.3841378 L10.7071009,15.7071068 Z" id="Path-94" fill="#000000" fill-rule="nonzero" opacity="0.3" transform="translate(15.999997, 11.999999) scale(-1, 1) rotate(-270.000000) translate(-15.999997, -11.999999) " />
							</g>
						</svg>
					</span>
				<span>
					<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
						<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
							<polygon id="Shape" points="0 0 24 0 24 24 0 24" />
							<path d="M12.2928955,6.70710318 C11.9023712,6.31657888 11.9023712,5.68341391 12.2928955,5.29288961 C12.6834198,4.90236532 13.3165848,4.90236532 13.7071091,5.29288961 L19.7071091,11.2928896 C20.085688,11.6714686 20.0989336,12.281055 19.7371564,12.675721 L14.2371564,18.675721 C13.863964,19.08284 13.2313966,19.1103429 12.8242777,18.7371505 C12.4171587,18.3639581 12.3896557,17.7313908 12.7628481,17.3242718 L17.6158645,12.0300721 L12.2928955,6.70710318 Z" id="Path-94" fill="#000000" fill-rule="nonzero" />
							<path d="M3.70710678,15.7071068 C3.31658249,16.0976311 2.68341751,16.0976311 2.29289322,15.7071068 C1.90236893,15.3165825 1.90236893,14.6834175 2.29289322,14.2928932 L8.29289322,8.29289322 C8.67147216,7.91431428 9.28105859,7.90106866 9.67572463,8.26284586 L15.6757246,13.7628459 C16.0828436,14.1360383 16.1103465,14.7686056 15.7371541,15.1757246 C15.3639617,15.5828436 14.7313944,15.6103465 14.3242754,15.2371541 L9.03007575,10.3841378 L3.70710678,15.7071068 Z" id="Path-94" fill="#000000" fill-rule="nonzero" opacity="0.3" transform="translate(9.000003, 11.999999) rotate(-270.000000) translate(-9.000003, -11.999999) " />
						</g>
					</svg>
				</span>
				</button>
			</div>
		</div>
		<div class="kt-aside-menu-wrapper kt-grid__item kt-grid__item--fluid" id="kt_aside_menu_wrapper">
			<div id="kt_aside_menu" class="kt-aside-menu " data-ktmenu-vertical="1" data-ktmenu-scroll="1" data-ktmenu-dropdown-timeout="500">
				<ul class="kt-menu__nav">
					<router-link  class="kt-menu__item" to="/dashboard">
						<a class="kt-menu__link">
							<span class="kt-menu__link-icon"><i class="kt-menu__link-icon flaticon-layers"></i></span>
							<span class="kt-menu__link-text">Dashboard</span>
						</a>
					</router-link>
					<li class="kt-menu__item  kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
						<a href="javascript:;" class="kt-menu__link kt-menu__toggle">
							<span class="kt-menu__link-icon">
							<i class="kt-menu__link-icon flaticon-list"></i>
							</span>
							<span class="kt-menu__link-text">Orders</span>
							<i class="kt-menu__ver-arrow la la-angle-right"></i>
						</a>
						<div class="kt-menu__submenu "><span class="kt-menu__arrow"></span>
							<ul class="kt-menu__subnav">
								<li class="kt-menu__item  kt-menu__item--parent" aria-haspopup="true">
									<span class="kt-menu__link">
										<span class="kt-menu__link-text">Orders</span></span>
								</li>
								<router-link  class="kt-menu__item" aria-haspopup="true" to="/dashboard/orders/create" exact>
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Add New Order</span>
									</a>
								</router-link>
								<router-link  class="kt-menu__item" aria-haspopup="true" to="/dashboard/orders" exact>
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Orders List</span>
									</a>
								</router-link>
								<router-link  class="kt-menu__item" aria-haspopup="true" to="/dashboard/settings/coming_soon">
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Export Orders</span>
									</a>
								</router-link>
								<router-link  class="kt-menu__item" aria-haspopup="true" to="/dashboard/settings/coming_soon">
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Filter Orders</span>
									</a>
								</router-link>
							</ul>
						</div>
					</li>
					<li class="kt-menu__item  kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover"
                        v-if="['admin', 'owner'].includes(this.$store.getters.role) &&  this.$store.getters.permissions.includes('customer')">
						<a href="javascript:;" class="kt-menu__link kt-menu__toggle">
							<span class="kt-menu__link-icon">
							<i class="kt-menu__link-icon flaticon-users-1"></i>
							</span>
							<span class="kt-menu__link-text">Customers</span>
							<i class="kt-menu__ver-arrow la la-angle-right"></i>
						</a>
						<div class="kt-menu__submenu "><span class="kt-menu__arrow"></span>
							<ul class="kt-menu__subnav">
								<li class="kt-menu__item  kt-menu__item--parent" aria-haspopup="true">
									<span class="kt-menu__link">
										<span class="kt-menu__link-text">Customers</span></span>
								</li>
								<router-link  class="kt-menu__item" aria-haspopup="true" to="/dashboard/customers/create" exact>
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Add New Customer</span>
									</a>
								</router-link>
								<router-link  class="kt-menu__item" aria-haspopup="true" to="/dashboard/customers" exact>
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Customers List</span>
									</a>
								</router-link>
								<router-link  class="kt-menu__item" aria-haspopup="true" to="/dashboard/settings/coming_soon">
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Import/Export</span>
									</a>
								</router-link>
							</ul>
						</div>
					</li>
					<li class="kt-menu__item  kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
						<a href="javascript:;" class="kt-menu__link kt-menu__toggle">
							<span class="kt-menu__link-icon">
							<i class="kt-menu__link-icon la la-cubes"></i>
							</span>
							<span class="kt-menu__link-text">Products</span>
							<i class="kt-menu__ver-arrow la la-angle-right"></i>
						</a>
						<div class="kt-menu__submenu "><span class="kt-menu__arrow"></span>
							<ul class="kt-menu__subnav">
								<li class="kt-menu__item  kt-menu__item--parent" aria-haspopup="true">
									<span class="kt-menu__link">
										<span class="kt-menu__link-text">Products</span></span>
								</li>
								<router-link  class="kt-menu__item"  aria-haspopup="true" to="/dashboard/products/create" exact>
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Add New Product</span>
									</a>
								</router-link>
                                <router-link  class="kt-menu__item"  aria-haspopup="true" to="/dashboard/products" exact>
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Products List</span>
									</a>
								</router-link>
								<router-link  class="kt-menu__item" aria-haspopup="true" to="/dashboard/price-tiers">
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Price Tiers</span>
									</a>
								</router-link>
								<router-link  class="kt-menu__item" aria-haspopup="true" to="/dashboard/volume-price-tiers">
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Volume Price Tiers</span>
									</a>
								</router-link>
								<router-link  class="kt-menu__item" aria-haspopup="true" to="/shopify/misc-settings">
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Import/Export</span>
									</a>
								</router-link>
							</ul>
						</div>
					</li>
                    <!--********************** Categories ***********************************************-->
                    <li class="kt-menu__item  kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
                        <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
							<span class="kt-menu__link-icon">
							<i class="kt-menu__link-icon la la-folder-open"></i>
							</span>
                            <span class="kt-menu__link-text">Categories</span>
                            <i class="kt-menu__ver-arrow la la-angle-right"></i>
                        </a>
                        <div class="kt-menu__submenu "><span class="kt-menu__arrow"></span>
                            <ul class="kt-menu__subnav">
                                <li class="kt-menu__item  kt-menu__item--parent" aria-haspopup="true">
									<span class="kt-menu__link">
										<span class="kt-menu__link-text">Categories</span></span>
                                </li>
                                <router-link  class="kt-menu__item" aria-haspopup="true" to="/dashboard/categories">
                                    <a class="kt-menu__link">
                                        <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                                            <span></span></i>
                                        <span class="kt-menu__link-text">Category List</span>
                                    </a>
                                </router-link>
                                <router-link  class="kt-menu__item" aria-haspopup="true" to="/dashboard/categories/create">
                                    <a class="kt-menu__link">
                                        <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                                            <span></span></i>
                                        <span class="kt-menu__link-text">Add Category</span>
                                    </a>
                                </router-link>
                            </ul>
                        </div>
                    </li>
					<li class="kt-menu__item  kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
						<a href="javascript:;" class="kt-menu__link kt-menu__toggle">
							<span class="kt-menu__link-icon">
							<i class="kt-menu__link-icon fa fa-users"></i>
							</span>
							<span class="kt-menu__link-text">Staff</span>
							<i class="kt-menu__ver-arrow la la-angle-right"></i>
						</a>
						<div class="kt-menu__submenu "><span class="kt-menu__arrow"></span>
							<ul class="kt-menu__subnav">
								<li class="kt-menu__item  kt-menu__item--parent" aria-haspopup="true">
									<span class="kt-menu__link">
										<span class="kt-menu__link-text">Staff</span></span>
								</li>
                                <router-link  class="kt-menu__item" aria-haspopup="true" to="/dashboard/staff">
                                    <a class="kt-menu__link">
                                        <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                                            <span></span></i>
                                        <span class="kt-menu__link-text">Staff List</span>
                                    </a>
                                </router-link>
								<router-link  class="kt-menu__item" aria-haspopup="true" to="/dashboard/staff/create">
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Add Staff Member</span>
									</a>
								</router-link>
                                <router-link  class="kt-menu__item" aria-haspopup="true" to="/dashboard/staff/roles">
                                    <a class="kt-menu__link">
                                        <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                                            <span></span></i>
                                        <span class="kt-menu__link-text">Permissions</span>
                                    </a>
                                </router-link>
                                <router-link  class="kt-menu__item" aria-haspopup="true" to="/dashboard/settings/coming_soon">
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Commissions</span>
									</a>
								</router-link>
							</ul>
						</div>
					</li>
					<li class="kt-menu__item  kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
						<a href="javascript:;" class="kt-menu__link kt-menu__toggle">
							<span class="kt-menu__link-icon">
							<i class="kt-menu__link-icon la la-barcode"></i>
							</span>
							<span class="kt-menu__link-text">Documents</span>
							<i class="kt-menu__ver-arrow la la-angle-right"></i>
						</a>
						<div class="kt-menu__submenu "><span class="kt-menu__arrow"></span>
							<ul class="kt-menu__subnav">
								<li class="kt-menu__item  kt-menu__item--parent" aria-haspopup="true">
									<span class="kt-menu__link">
										<span class="kt-menu__link-text">Documents</span></span>
								</li>
							</ul>
						</div>
					</li>
					<!--********************** Reports ***************************************************-->
					<li class="kt-menu__item  kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
						<a href="javascript:;" class="kt-menu__link kt-menu__toggle">
							<span class="kt-menu__link-icon">
								<i class="kt-menu__link-icon la la-th-list"></i>
							</span>
							<span class="kt-menu__link-text">Reports</span>
							<i class="kt-menu__ver-arrow la la-angle-right"></i>
						</a>
						<div class="kt-menu__submenu "><span class="kt-menu__arrow"></span>
							<ul class="kt-menu__subnav">
								<li class="kt-menu__item  kt-menu__item--parent" aria-haspopup="true">
									<span class="kt-menu__link">
										<span class="kt-menu__link-text">Reports</span></span>
								</li>
								<router-link  class="kt-menu__item" aria-haspopup="true" to="/Settings/shipment_methods_settings">
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Sale by Customer</span>
									</a>
								</router-link>
								<router-link  class="kt-menu__item" aria-haspopup="true" to="/shopify/misc-settings">
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Sale by Product and Customer</span>
									</a>
								</router-link>
							</ul>
						</div>
					</li>
					<!--.............................End Report........................................-->					
					<li class="kt-menu__item  kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
						<a href="javascript:;" class="kt-menu__link kt-menu__toggle">
							<span class="kt-menu__link-icon">
								<i class="kt-menu__link-icon">
									<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
								    	<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
								        <rect opacity="0.200000003" x="0" y="0" width="24" height="24"/>
								        <path d="M4.5,7 L9.5,7 C10.3284271,7 11,7.67157288 11,8.5 C11,9.32842712 10.3284271,10 9.5,10 L4.5,10 C3.67157288,10 3,9.32842712 3,8.5 C3,7.67157288 3.67157288,7 4.5,7 Z M13.5,15 L18.5,15 C19.3284271,15 20,15.6715729 20,16.5 C20,17.3284271 19.3284271,18 18.5,18 L13.5,18 C12.6715729,18 12,17.3284271 12,16.5 C12,15.6715729 12.6715729,15 13.5,15 Z" fill="#000000" opacity="0.3"/>
								        <path d="M17,11 C15.3431458,11 14,9.65685425 14,8 C14,6.34314575 15.3431458,5 17,5 C18.6568542,5 20,6.34314575 20,8 C20,9.65685425 18.6568542,11 17,11 Z M6,19 C4.34314575,19 3,17.6568542 3,16 C3,14.3431458 4.34314575,13 6,13 C7.65685425,13 9,14.3431458 9,16 C9,17.6568542 7.65685425,19 6,19 Z" fill="#000000"/>
								    	</g>
									</svg>
								</i>
							</span>
							<span class="kt-menu__link-text">Settings</span>
							<i class="kt-menu__ver-arrow la la-angle-right"></i>
						</a>
						<div class="kt-menu__submenu "><span class="kt-menu__arrow"></span>
							<ul class="kt-menu__subnav">
								<li class="kt-menu__item  kt-menu__item--parent" aria-haspopup="true">
									<span class="kt-menu__link">
										<span class="kt-menu__link-text">Settings</span></span>
								</li>
								<router-link  class="kt-menu__item" aria-haspopup="true" to="/dashboard/settings/coming_soon">
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Store Settings</span>
									</a>
								</router-link>
								<router-link  class="kt-menu__item" aria-haspopup="true" to="/dashboard/settings/shipment_methods_settings">
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Shipment Methods</span>
									</a>
								</router-link>
								<router-link  class="kt-menu__item" aria-haspopup="true" to="/dashboard/settings/coming_soon">
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Misc Settings</span>
									</a>
								</router-link>
								<router-link  class="kt-menu__item" aria-haspopup="true" to="/dashboard/settings/coming_soon">
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Subscription</span>
									</a>
								</router-link>
                                <router-link  class="kt-menu__item" aria-haspopup="true" to="/dashboard/settings/signup-form">
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Signup Form</span>
									</a>
								</router-link>
								<router-link  class="kt-menu__item" aria-haspopup="true" to="/dashboard/settings/coming_soon">
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Brand Info</span>
									</a>
								</router-link>
                                <router-link  class="kt-menu__item" aria-haspopup="true" to="/dashboard/settings/brand-promo-codes">
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Promo Codes</span>
									</a>
								</router-link>
								<router-link  class="kt-menu__item" aria-haspopup="true" to="/dashboard/settings/vendors">
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Vendors</span>
									</a>
								</router-link>
							</ul>
						</div>
					</li>					
					<li class="kt-menu__item  kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover"
                        v-if="['admin', 'owner'].includes(this.$store.getters.role)">
						<a href="javascript:;" class="kt-menu__link kt-menu__toggle">
							<span class="kt-menu__link-icon">
							<i class="kt-menu__link-icon flaticon-cogwheel"></i>
							</span>
							<span class="kt-menu__link-text">Integrations</span>
							<i class="kt-menu__ver-arrow la la-angle-right"></i>
						</a>
						<div class="kt-menu__submenu "><span class="kt-menu__arrow"></span>
							<ul class="kt-menu__subnav">
								<li class="kt-menu__item  kt-menu__item--parent" aria-haspopup="true">
									<span class="kt-menu__link">
										<span class="kt-menu__link-text">Integrations</span></span>
								</li>
								<router-link  class="kt-menu__item" aria-haspopup="true" to="/dashboard/integrations">
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Integrations</span>
									</a>
								</router-link>
							</ul>
						</div>
					</li>

                    <!--............................. begin::Shopify ........................................-->
					<li class="kt-menu__item  kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover"
                        v-if="['admin', 'owner'].includes(this.$store.getters.role)">
                        <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
							<span class="kt-menu__link-icon">
							<i class="kt-menu__link-icon fa fa-dollar-sign"></i>
							</span>
							<span class="kt-menu__link-text">Shopify</span>
							<i class="kt-menu__ver-arrow la la-angle-right"></i>
						</a>
						<div class="kt-menu__submenu "><span class="kt-menu__arrow"></span>
							<ul class="kt-menu__subnav">
								<li class="kt-menu__item  kt-menu__item--parent" aria-haspopup="true">
									<span class="kt-menu__link">
										<span class="kt-menu__link-text">Shopify</span></span>
								</li>
								<router-link  class="kt-menu__item" aria-haspopup="true" to="/shopify/sync-products">
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Sync Products</span>
									</a>
								</router-link>
								<router-link  class="kt-menu__item" aria-haspopup="true" to="/shopify/misc-settings">
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Misc Settings</span>
									</a>
								</router-link>
							</ul>
						</div>
					</li>
                    <!--............................. end::Shopify ........................................-->

					<li class="kt-menu__item  kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
						<a href="javascript:;" class="kt-menu__link kt-menu__toggle">
							<span class="kt-menu__link-icon">
							<i class="kt-menu__link-icon fa fa-donate"></i>
							</span>
							<span class="kt-menu__link-text">QuickBooks</span>
							<i class="kt-menu__ver-arrow la la-angle-right"></i>
						</a>
						<div class="kt-menu__submenu "><span class="kt-menu__arrow"></span>
							<ul class="kt-menu__subnav">
								<li class="kt-menu__item  kt-menu__item--parent" aria-haspopup="true">
									<span class="kt-menu__link">
										<span class="kt-menu__link-text">QuickBooks</span></span>
								</li>
								<router-link  class="kt-menu__item" aria-haspopup="true" to="/dashboard/settings/coming_soon">
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Sync Orders</span>
									</a>
								</router-link>
								<router-link  class="kt-menu__item" aria-haspopup="true" to="/dashboard/settings/coming_soons">
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Link Items</span>
									</a>
								</router-link>
								<router-link  class="kt-menu__item" aria-haspopup="true" to="/dashboard/settings/coming_soon">
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Link Customers</span>
									</a>
								</router-link>
								<router-link  class="kt-menu__item" aria-haspopup="true" to="/quickbooks/misc-settings">
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Misc Settings</span>
									</a>
								</router-link>
							</ul>
						</div>
					</li>
					<li class="kt-menu__item  kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
						<a href="javascript:;" class="kt-menu__link kt-menu__toggle">
							<span class="kt-menu__link-icon">
							<i class="kt-menu__link-icon fa fa-shipping-fast"></i>
							</span>
							<span class="kt-menu__link-text">ShipStation</span>
							<i class="kt-menu__ver-arrow la la-angle-right"></i>
						</a>
						<div class="kt-menu__submenu "><span class="kt-menu__arrow"></span>
							<ul class="kt-menu__subnav">
								<li class="kt-menu__item  kt-menu__item--parent" aria-haspopup="true">
									<span class="kt-menu__link">
										<span class="kt-menu__link-text">ShipStation</span></span>
								</li>
								<router-link  class="kt-menu__item" aria-haspopup="true" to="/shipstation/sync-products">
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Sync Products</span>
									</a>
								</router-link>
								<router-link  class="kt-menu__item" aria-haspopup="true" to="/shipstation/misc-settings">
									<a class="kt-menu__link">
										<i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
										<span></span></i>
										<span class="kt-menu__link-text">Misc Settings</span>
									</a>
								</router-link>
							</ul>
						</div>
					</li>
					<li class="kt-menu__item  kt-menu__item--submenu" aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
						<a href="javascript:;" class="kt-menu__link kt-menu__toggle">
							<span class="kt-menu__link-icon ">
							<i class="kt-menu__link-icon fa fa-eye"></i>
							</span>
							<span class="kt-menu__link-text">Preview Customer Shop </span>
							<i class="kt-menu__ver-arrow la la-angle-right"></i>
						</a>
						<div class="kt-menu__submenu "><span class="kt-menu__arrow"></span>
							<ul class="kt-menu__subnav">
								<li class="kt-menu__item  kt-menu__item--parent" aria-haspopup="true">
									<span class="kt-menu__link">
										<span class="kt-menu__link-text">Preview Customer Shop</span></span>
								</li>
							</ul>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
export default {
  name: 'sidebar',
};
</script>
